module.exports = __webpack_public_path__ + "static/media/software-maintenance.7d1c8130.png";